import React from "react";
import { appMethod as app } from '@utils/app';
import OfficialPage from '../../official-page/OfficialPage';
import ReactDom from 'react-dom';
import { Toast, Icon } from 'antd-mobile';
import "./SharePage.less";
import TextAnimation from "../component/TextAnimation/TextAnimation";
import { getCurrentPageQueryParams } from '@utils/tools';
import Dialog from "../dialog/Dialog";
import CryptoJS from "crypto-js";
import RecorderManager from '../../utils/index.umd.js';
import LoginPage from "src/official-page/login-page/LoginPage";
import html2canvas from "html2canvas"
import { configWxShare } from '../../utils/weixinSdkConfig';

const GPTModal = {
  '0': 'GPT-3.5',
  '1': 'GPT-4'
}
const APPID = "2dcb30a7";
const API_SECRET = "Mzg2ZmYzNDIyZGQ1M2MzMDU4OWY5Yzc1";
const API_KEY = "9449a5280ed944fa8f53b23d5c1e90fd";

let longPressTimeout

export default class SharePage extends OfficialPage {
  countdownInterval = null
  recorder = null
  iatWS = null
  state = {
    canUseIntegral: 0,
    userVipCardInfo: null,
    historyNum: 0,
    roleList: [
      {
        role_id: 0,
        role_name: '会话',
        url: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/session_role.png'
      }
    ],
    roleListAll: [],
    selectedRoleId: '',
    switchSelectedRoleId: '',
    sessionId: '', //会话id
    dialogueList : [
            {
              "text": "你好。",
              "direction": "ques",
              "id": "805",
              "isHistory": true,
              "is_audio": "1"
            },
            {
              "text": "你好！有什么我可以帮助你的吗？",
              "direction": "reply",
              "id": "806",
              "isHistory": true,
              "is_audio": "1"
            }
    ],
    is_more: 0,
    current_page: 1,
    content: '', //提问内容
    is_audio: 0, //提问方式   0打字提问 1语音提问
    shareKey: '',
    sharePoliteData: {},
    isWeiXinBrowser: false,
    isSub: false,
    isShowAllRole: false,
    searchValue: '',
    modalType: 0, // 模型
    modalName: 'GPT-3.5', // 模型名称
    modalId: '',
    modalList: [],
    isShowModalConfig: false,

    // 录音相关数据
    isAudio: true, // 是否切换为录音
    isRecording: false, // 正在录音
    // iatWS:null, //websocket
    resultText: '', // 文字结果
    resultTextTemp: '', // 文字修正结果
    // countdownInterval:null, // 时间计数器
    seconds: 60, // 倒计时
    recordInterrupt:false,
    // recorder:null,

    maskShow: false,
    isShare: false, // 正在分享
    shareDialogList:[], // 选择分享的内容
    lastDialogId:0,
    shareImgUrl:'',
    qrCodeImg:'',
    isLongPress:false,
    longPressInx:-1,
  }
  constructor(props) {
    super(props);
    document.title = '即速对话';
    this.myRef = React.createRef();
    this.textareaRef = React.createRef()
    if(app.isWeixin()){
      this.state.isWeiXinBrowser = true;
    }
  }
  componentDidMount(options = getCurrentPageQueryParams()) {
    // this.textareaRef.current && this.textareaRef.current.focus()
    // console.log(this.textareaRef,'33333')
    app.globalData.homepageRouter = 'jisugpt'; //将首页路径设置为gpt入口页
    // 为进入历史对话时
    if(options.sid && options.rid){
      this.setData({
        sessionId: options.sid,
        selectedRoleId: options.rid,
        switchSelectedRoleId: options.rid,
      })
      app.setStorage({
        key: 'nowSessionData',
        data: {
          sessionId: options.sid,
          roleId: options.rid
        }
      })
    }
    if (!app.isLogin()) {
      app.goLogin();
      return;
    }
    if(!app.getUserInfo().phone){
      Toast.info('请补充用户信息',1,()=>{
        app.turnToPage('add-phone')
      });
      return;
    }
  }

  render() {
    let { content, roleList, selectedRoleId, is_more, isWeiXinBrowser, isSub, roleListAll, switchSelectedRoleId, isShowAllRole, searchValue,
      modalName, modalId, modalList, isShowModalConfig, isAudio, isRecording, seconds,resultText,maskShow,isShare,qrCodeImg,isLongPress,longPressInx} = this.state;
    return (
      <div className="gpt_page" onClick={this.cancleLongPress}>
        {!isWeiXinBrowser &&
        <div className="head">
         { !isShare && 
         <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_l_big.png" alt="back" onClick={this.goBack}/>
         }
         { isShare && 
         <div className="head_btn" onClick={this.cancelShare}>取消</div>
         }
         <div>{isShare ? '选择分享内容' : '即速对话'}</div>
        </div>
        }
        <div className={'main ' + (isWeiXinBrowser?'':'pd_t35')} ref={this.myRef}>
        {is_more == 1 &&
          <div className="request-all" onClick={this.getMore}>点击加载更多</div>
        }
        {this.state.dialogueList.map((item,index) =>
          <div key={item.id + '-' + index} className="text_animation_box">
            {/* {item.direction != "reply" && isShare && <div className="select_share_btn img" style={{backgroundImage:`url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-select.png)`}}></div>} */}
            {item.direction != "reply" && (!isShare) && <div className="select_share_btn"></div>}
            {/* {item.direction != "reply" && isShare && <img className="select_share_btn" onClick={this.selectThisDialog.bind(this,index)} src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/copy.png" alt="" />} */}
            <TextAnimation data={item} againSend={this.againSend} toBoxBottom={this.toBoxBottom}/>
          </div>
          
        )}
        </div>
      </div>
      
    );
  }
}



// WEBPACK FOOTER //
// ./src/chatgpt-page/share-page/SharePage.jsx